import script from "./Cooperate.vue?vue&type=script&setup=true&lang=js"
export * from "./Cooperate.vue?vue&type=script&setup=true&lang=js"

import "./Cooperate.vue?vue&type=style&index=0&id=34d9bffc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\刘正希\\Desktop\\知谦\\zq\\webside\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34d9bffc"]])

export default __exports__